(function($) {
  'use strict';

  // Reinitialize slider on window size change.
  $(window).on('orientationchange', function() {
    $('.social-feed__list').slick('resize');
  });

  $('.social-feed__list').slick({
    mobileFirst: true,
    slidesToShow: 1,
    prevArrow: '.social-feed__slider-prev',
    nextArrow: '.social-feed__slider-next',
    responsive: [
      {
        breakpoint: 640,
        settings: 'unslick'
      }
    ]
  });
  $('.social-feed__list-item').attr('tabindex', '-1');
  $('.social-feed__item-link').attr('tabindex', '0');
  $('.social-feed__item-link').hover(
    function() {
      const $socialIconToReplace = $(this).find('.js-social-icon-toggle');
      const socialIconPrefix = $socialIconToReplace.data('icon-prefix');
      $socialIconToReplace.attr(
        'src',
        `/themes/custom/ccny_theme/dist/assets/${socialIconPrefix}-charcoal.svg`
      );
      const $arrowIconToReplace = $(this).find('.js-arrow-icon-toggle');
      const arrowIconSuffix = $arrowIconToReplace.data('icon-prefix');
      $arrowIconToReplace.attr(
        'src',
        `/themes/custom/ccny_theme/dist/assets/charcoal-${arrowIconSuffix}.svg`
      );
    },
    function() {
      const $socialIconToReplace = $(this).find('.js-social-icon-toggle');
      const socialIconPrefix = $socialIconToReplace.data('icon-prefix');
      $socialIconToReplace.attr(
        'src',
        `/themes/custom/ccny_theme/dist/assets/${socialIconPrefix}.svg`
      );
      const $arrowIconToReplace = $(this).find('.js-arrow-icon-toggle');
      const arrowIconSuffix = $arrowIconToReplace.data('icon-prefix');
      $arrowIconToReplace.attr(
        'src',
        `/themes/custom/ccny_theme/dist/assets/${arrowIconSuffix}.svg`
      );
    }
  );
})(jQuery);
